import { EProblemReportStatus } from '@constants';
import { Popover } from 'antd';
import { useState } from 'react';

import { ProblemReportStatus } from '../ProblemReportStatus';
import { ProblemReportStatusSelector } from '../ProblemReportStatusSelector';

type Props = {
  status: EProblemReportStatus;
  problemReportId: string;
  reportId: string;
  userName: string;
  activityName: string;
  id?: string;
};

export const StatusCell: React.FC<Props> = ({
  status,
  problemReportId,
  reportId,
  userName,
  activityName,
  id
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const closePopover = () => setIsOpen(false);

  return (
    <div id={id}>
      <Popover
        open={isOpen}
        onOpenChange={setIsOpen}
        content={
          <ProblemReportStatusSelector
            problemReportId={problemReportId}
            reportId={reportId}
            userName={userName}
            activityName={activityName}
            onStatusChange={closePopover}
          />
        }
        trigger="click">
        <ProblemReportStatus status={status} isOpen={isOpen} />
      </Popover>
    </div>
  );
};
